export function ensureChildrenVisibility(container, targetChildren) {
  var isOutOfUpperView = targetChildren.offsetTop < container.scrollTop;
  var isOutOfLowerView = targetChildren.offsetTop + targetChildren.clientHeight > container.scrollTop + container.clientHeight;
  if (isOutOfUpperView) {
    container.scrollTop = targetChildren.offsetTop;
  } else if (isOutOfLowerView) {
    container.scrollTop = targetChildren.offsetTop + targetChildren.clientHeight - container.clientHeight;
  }
}